import request from '@/utils/request'

/*查询汇率设置列表*/
export function fetchList(params) {
  return request({
    url:'/exchangeRateSetting/list',
    method:'get',
    params:params
  })
}

/*创建汇率设置*/
export function createExchangeRateSetting(data) {
    return request({
        url:'/exchangeRateSetting/create',
        method:'post',
        data:data
    })
}

/*更新汇率设置*/
export function updateExchangeRateSetting(id,data) {
    return request({
        url:'/exchangeRateSetting/update/'+id,
        method:'post',
        data:data
    })
}

/*删除汇率设置*/
export function deleteExchangeRateSetting(id,data) {
    return request({
        url:'/exchangeRateSetting/delete/'+id,
        method:'get',
    })
}

/*实时更新汇率*/
export function realTimeUpdate(data) {
    return request({
        url:'/exchangeRateSetting/realTimeUpdate',
        method:'post',
    })
}

/*实时汇率转换*/
export function realTimeExchangeRateConver(params) {
    return request({
        url:'/exchangeRateSetting/realTimeExchangeRateConver',
        method:'get',
        params:params
    })
}



// WEBPACK FOOTER //
// ./src/api/exchangeRateSetting.js